import axios from "axios";

export default axios.create({
  baseURL: "https://submit-form.com/75mlXBd7IeDkfNsZoyxgQ",
  responseType: "json"
});
